(
<span *ngIf="percentage >= 0"> +{{ percentage }} </span>
<span *ngIf="percentage < 0"> {{ percentage }} </span>
%)
